<template>

    <div id="agility_tab" class="flex_content scores_table_container" >

        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <TableWrapper tableContainerId="positions_table_container" class="with_shadow">

                    <template v-slot:tableHead>
                        <tr>
                            <th></th>
                            <th></th>
                            <!--
                            <th  :class="matchingSortingActive()"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('matching_score')">%</th>
                            -->
                            <th :class="activeSortingClass('ai')"
                                class="sortable_column"
                                @click="reorderEval('ai')">
                                {{ labels['ai'] }}
                            </th>
                            <th :class="activeSortingClass('as')"
                                class="sortable_column"
                                @click="reorderEval('as')">
                                {{ labels['as'] }}
                            </th>
                            <th :class="activeSortingClass('am')"
                                class="sortable_column"
                                @click="reorderEval('am')">
                                {{ labels['am'] }}
                            </th>
                            <th :class="activeSortingClass('ac')"
                                class="sortable_column"
                                @click="reorderEval('ac')">
                                {{ labels['ac'] }}
                            </th>
                            <th :class="activeSortingClass('ag')"
                                class="sortable_column"
                                @click="reorderEval('ag')">
                                {{ labels['ag'] }}
                            </th>
                        </tr>
                    </template>

                    <template v-slot:tableBody>

                        <tr class=""
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >

                            <td>
                                <!--<TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id"
                                    @change="checkSelectedEval($event, evaluation.id)"
                                    :isChecked="isSelected(evaluation.id)" />-->
                            </td>

                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>
                            <!--
                            <td class="matching_col"
                                :class="matchingClass(evaluation.saven_test.matching_score.toFixed(0))">
                                {{ evaluation.saven_test.matching_score.toFixed(0) }}%
                            </td>
                            -->
                            <td class="normal_score_container">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.agilities_base.ai.toFixed(0))">
                                    {{ evaluation.saven_test.agilities_base.ai.toFixed(0) }}
                                </div>
                            </td>
                            <td class="normal_score_container">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.agilities_base.as.toFixed(0))">
                                    {{ evaluation.saven_test.agilities_base.as.toFixed(0) }}
                                </div>
                            </td>
                            <td class="normal_score_container">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.agilities_base.am.toFixed(0))">
                                    {{ evaluation.saven_test.agilities_base.am.toFixed(0) }}
                                </div>
                            </td>
                            <td class="normal_score_container">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.agilities_base.ac.toFixed(0))">
                                    {{ evaluation.saven_test.agilities_base.ac.toFixed(0) }}
                                </div>
                            </td>
                            <td class="normal_score_container">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.agilities_base.ag.toFixed(0))">
                                    {{ evaluation.saven_test.agilities_base.ag.toFixed(0) }}
                                </div>
                            </td>

                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>
import s3AgilitiesLabels from '@/locales/s3AgilitiesLabels'


export default {
    name: 'PostitionEvalsAgilityTab',
    props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
    components: {},
    beforeCreate() {},
    data(){
        return {
            current_sorting: null
        }
    },
    computed: {
        labels(){
            return s3AgilitiesLabels[this.$i18n.locale]
        }
    },
    methods: {
        isSelected(evaluationId){
            return this.$store.state.PositionStore.SelectedPositionEvalsIds.includes(evaluationId)
        },
        checkSelectedEval(isChecked, evaluationId){
            this.$emit("SelectionCheckBoxClicked",{isChecked: isChecked, evaluationId: evaluationId} )
        },
        reorderEval(key){
            this.current_sorting = key
            this.$emit('reorderEval', key)
        },
        activeSortingClass(key){
            if (key  == this.current_sorting){
                return 'active'
            }else{
                return ''
            }
        },
        // matchingSortingActive(){
        //     if ('matching_score' == this.current_sorting){
        //         return 'active'
        //     }else{
        //         return ''
        //     }
        // },
        // matchingClass(val){
        //     if(val < 25){return 'low'}
        //     if(val >= 25 && val < 50){return 'middleLow'}
        //     if(val >= 50 && val < 75){return 'middleHigh'}
        //     if(val >= 75){return 'high'}
        // },
        scoreClass(score){
            // return "is_score_" + score
            return "no_ref_score"
        }
    }
}
</script>

<style lang="scss">
</style>